export function addAlpha(color: string, opacity: number) {
    return color + Math.floor((opacity / 10) * 255).toString(16);
}
